module.exports = __webpack_public_path__ + "img/Cornell.a1a5578f.png";